<template>
  <PRICE_VAT_TIP :show="showVATTip" :currentCountry="currentCountry" />
  <slot name="default" v-if="!showVATTip" />
</template>
<script>
import { get } from 'lodash';
import { mapGetters } from "vuex";

import {
  PriceVatTip,
  getTaxExclusions,
} from '@zoom/fe-billing-components';

export default {
  name: 'priceVATTip',
  components: {
    PRICE_VAT_TIP: PriceVatTip,
  },
  computed: {
    ...mapGetters([
      'soldToContact',
    ]),
    currentCountry () {
      const { soldTo } = get(window.newBillingConfig, 'billingCountry', {})
      return get(this.soldToContact, 'country') || soldTo || get(window.newBillingConfig, 'currentCountry', '')
    },
    showVATTip() {
      return getTaxExclusions().some(c => c.id === this.currentCountry);
    }
  },
};
</script>
<style lang="scss">
.opc-cart__total__text__sub {
  .VAT-tip + * {
    display: none;
  }
}
</style>

